var labelResponses = {};
var minStimsToLabel = 0;
var minLabelsToUse = 0;

function showResponseLabels(formInfo){
    initResponseLabelsConditions();
    var $labelContainer = $('#responseLabelContainer');
    $labelContainer.show();
    console.log('show response labels called');
    var labels = formInfo.responseChoices;
    for(var i in labels){
        var $currentResponseLabel = createResponseLabel(labels[i]);
        $labelContainer.append($currentResponseLabel);
        $currentResponseLabel.draggable({
            revert:"invalid",
            start: function(event, ui){
                $('.ui-droppable').droppable('enable');
            }
        });
    }
    makeImagesDroppable();

    $labelContainer.css({
        "top": window.maxTrialBottom +
            $labelContainer.height() +
            50 +
            "px",
        "left": (canvasWidth/2 - $labelContainer.width()/2) + "px",
        "padding": "8px",
    });

    $labelContainer.droppable({
        drop: function(event, ui) {
            for(var i in labelResponses){
                if(labelResponses[i] == ui.draggable.text()){
                    labelResponses[i] = "";
                }
            }
            ui.draggable.detach().css({
                position: "relative",
                top: 0,
                left: 0
            }).appendTo($(this));
            verifyLabelsResponse();
        }
    });

    if (!trialHasButtonsActive(window.trialRow)) {
        const labelContainerTop = parseInt($labelContainer.css('top')) + 100;
        var submitControls = '<button id="submitResponseLabels" class="btn btn-primary" type="button" style="font-size:180%;display:block;margin-left:auto;margin-right:auto;margin-top:' + labelContainerTop + 'px;" onclick="saveResponseLabels()">NEXT</button>';
        $('#responseContainer').append(submitControls);
    } else {
        let button = document.getElementById('button1');
        button.setAttribute('onclick', 'saveResponseLabels()');
    }

    window.enableResponseWindowAfterMinimumDuration(disableResponseLabels, enableResponseLabels);

    verifyLabelsResponse();
}

function createResponseLabel(label){
    var $responseLabel = $('<li>', {
        class: 'responseLabel',
        text: label,
    });
    return $responseLabel;
}

function makeImagesDroppable(){
    for(var i = 1; i <= window.listNoStim[window.trialRow]; i++){
        //labelResponses["stim" + i] = [];
        labelResponses["stim" + i] = "";
        $("#image" + i).droppable({
            drop: function(event, ui) {
                //extract only trailing digits from name of element i.e stim1,stim2,...stimN
                var currentStim = "stim" + $(this).attr('id').replace(/^\D+/g, '');
                for(var i in labelResponses){
                    if(labelResponses[i] == ui.draggable.text()){
                        labelResponses[i] = "";
                    }
                }
                labelResponses[currentStim] = ui.draggable.text();
                $('.ui-droppable').droppable('disable');

                var stimPos = $(this).position();
                ui.draggable.detach().css({
                    position: "absolute",
                    top: stimPos.top,
                    left: stimPos.left
                }).appendTo($('#displayScreen'));
                verifyLabelsResponse();
            },
            over: function(event, ui){
                //extract only trailing digits from name of element i.e image1,image2,...imageN
                var currentStim = "stim" + $(this).attr('id').replace(/^\D+/g, '');
                if(labelResponses[currentStim].length && ui.draggable.text() != labelResponses[currentStim]){
                    $(this).droppable('disable');
                }
            }
        });
    }
}

function getLabelResponses(){
    var response = "";
    for(var i in labelResponses){

        if(labelResponses[i].length > 0){
            /* To be used when stims will accept more than one label
            response += labelResponses[i].join(',') + ';';
            */
            response += labelResponses[i]+ ';';
        }
        else{
            response += ';';
        }
    }
    response = response.slice(0,-1); //remove last ;
    return response;
}

function saveResponseLabels(){
    saveTrial(getLabelResponses());
    labelResponses = {}
    clearDroppables();
    clearTimeouts();
    endTrial();
}

function clearDroppables(){
    $('.responseLabel').remove();
    $('#submitResponseLabels').remove();
    $("#button1").attr("onclick", "clickButton1()");

    for(var i = 1; i <= window.listNoStim[window.trialRow]; i++){
        if ($('#image' + i).data('ui-droppable')) {
            $('#image' + i).droppable("destroy");
        }
    }

    $('#responseLabelContainer').hide();
}

function initResponseLabelsConditions(){
    var conditions = columnForTrial('required', trialRow).split(';');
    for(var i in conditions){
        conditions[i] = conditions[i].split(':');
        if(conditions[i][0] == 'labels'){
            minLabelsToUse = parseInt(conditions[i][1]);
        }
        if(conditions[i][0] == 'stim'){
            minStimsToLabel = parseInt(conditions[i][1]);
        }
    }
}

function verifyLabelsResponse(){
    var countStimsLabeled = 0;
    var countLabelsUsed = 0;
    for(var i in labelResponses){
        if(labelResponses[i].length > 0){
            countStimsLabeled++;
            countLabelsUsed ++;
        }
    }
    console.log('verify labels', countStimsLabeled, countLabelsUsed, minStimsToLabel, minLabelsToUse);
    if(countStimsLabeled >= minStimsToLabel && countLabelsUsed >= minLabelsToUse){
        $('#submitResponseLabels').show();
    }
    else{
        $('#submitResponseLabels').hide();
    }
}

function disableResponseLabels() {
    document.getElementById("submitResponseLabels").setAttribute("disabled", "");
}

function enableResponseLabels() {
    document.getElementById("submitResponseLabels").removeAttribute("disabled");
}